{
  "slug": "ai-and-iq-testing",
  "title": "AI and IQ Testing",
  "description": "Generative AI changes test security, item generation, accessibility, scoring claims, privacy, and unsupervised interpretation.",
  "category": "Research explainers",
  "sections": [
    {
      "heading": "Research question",
      "paragraphs": [
        "Generative AI changes test security, item generation, accessibility, scoring claims, privacy, and unsupervised interpretation.",
        "Good summaries state what was measured, who participated, when, and whether the design supports causation."
      ]
    },
    {
      "heading": "Evidence checklist",
      "paragraphs": [
        "Look for transparent methods, validated measures, power, effect sizes with intervals, missing-data handling, and replication.",
        "Statistical significance does not automatically imply a useful effect."
      ]
    },
    {
      "heading": "Reporting",
      "paragraphs": [
        "Separate findings from interpretation, disclose limitations and conflicts, and link the primary paper.",
        "Publication begins evaluation; it is not the final word."
      ]
    }
  ],
  "related": ["how-is-iq-measured", "iq-vs-intelligence", "historical-iq-trends"],
  "sources": [],
  "faqs": [],
  "summary": "Generative AI changes test security, item generation, accessibility, scoring claims, privacy, and unsupervised interpretation. Content reviewed 18 July 2026."
}
